module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('i', {
    staticClass: "ui globe icon"
  }), _vm._v("\n    Choose your preferred language\n    "), _c('div', {
    staticClass: "ui simple dropdown right labeled icon button"
  }, [_c('span', [_vm._v("Cantonese")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("English")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("French")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Cantonese")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Arabic")])]), _vm._v(" "), _c('i', {
    staticClass: "ui dropdown icon"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1e8e2924"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteLanguage.vue
// module id = 384
// module chunks = 1